import { Tag } from "primereact/tag";

import {
  describePayerTaxonomyRule,
  isPayerTaxonomyRuleList,
  RULE_HEADLINE_FIELDS,
} from "../utils/sftpPartners";

// The account a partner loads into. SftpIngestionPartner.accountId has no foreign key, so the account
// can be gone: then the raw id is shown, flagged — the same on the list, the detail page and the form.
export function SftpAccountName({
  accountId,
  accountName,
}: {
  accountId: string;
  accountName: string | null;
}) {
  if (accountName) return <span>{accountName}</span>;
  return (
    <span className="inline-flex align-items-center gap-2">
      <code className="text-600">{accountId}</code>
      <Tag severity="danger" value="Account not found" />
    </span>
  );
}

// Every setting of a stored mapping rule other than claim type, provider and place of service —
// always shown in full. Known settings are described; anything else is shown as formatted JSON.
export function SftpRuleSettings({
  rule,
  payerNames = {},
}: {
  rule: Record<string, unknown>;
  payerNames?: Record<string, string>;
}) {
  const extras = Object.entries(rule).filter(
    ([key]) => !RULE_HEADLINE_FIELDS.includes(key)
  );
  if (!extras.length) return null;
  return (
    <ul className="mt-2 mb-0 pl-4 text-sm" data-testid="sftp-rule-settings">
      {extras.map(([key, value]) => {
        if (key === "excludeMidlevels" && typeof value === "boolean") {
          return (
            <li key={key}>
              Midlevel providers (NP, PA, audiology, LCSW):{" "}
              {value ? "excluded" : "included"}
            </li>
          );
        }
        if (key === "excludeBehavioralHealth" && typeof value === "boolean") {
          return (
            <li key={key}>
              Behavioral health: {value ? "excluded" : "included"}
            </li>
          );
        }
        if (key === "payerTaxonomyRules" && isPayerTaxonomyRuleList(value)) {
          return (
            <li key={key}>
              Taxonomy filters by payer:
              {value.length ? (
                <ul className="pl-4">
                  {value.map((r) => (
                    <li key={r.payerIds.join(",")}>
                      {describePayerTaxonomyRule(r, payerNames)}
                    </li>
                  ))}
                </ul>
              ) : (
                " none"
              )}
            </li>
          );
        }
        return (
          <li key={key}>
            {key}:
            <pre className="m-0 mt-1 p-2 surface-100 border-round overflow-auto">
              {JSON.stringify(value, null, 2)}
            </pre>
          </li>
        );
      })}
    </ul>
  );
}
